import React from 'react'
import { find } from 'lodash'

import { replaceExpression } from '../utils'

function TableColumn(props) {
    const { option, answermap, value, originalValue } = props

    return (
        [
            <td key={"60%"} width="60%">
                <div className="text">{replaceExpression(option.optionText, answermap)}</div>
            </td>,
            <td key={"20%+span"} width="20%">
                {originalValue && <span className="original">{originalValue}</span>}
            </td>,
            <td key={"20%"} width="20%">
                {value}
            </td>
        ]
    )
}

export default class PrintNumericQuestion extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            rows: [],
            allComments: []
        }
    }

  componentDidMount() {
    this.prepareTable(this.props.data)
  }

  prepareTable(question) {
    let currentRow = {row: 0}
    let rows = []

    question.options.map(option => {
      if (currentRow.row !== option.row) {
        currentRow = { row: option.row, columns: [] }
        rows.push(currentRow)
      }
      return currentRow.columns.push(option)
    })
    this.setState({rows: rows})
  }

    getCommentForQuestion(questionId) {
        const { allComments } = this.props
        const comment = allComments.find((c) => c.questionId === questionId)
        return comment ? comment.comment : null
    }

    getValue(optionId) {
        const value = find(this.props.state, s => s.optionId === optionId)
        return value && value.stringValue
    }

    getOriginalValue(optionId) {
        let value = undefined

        if (this.props.originalState) {
            value = find(this.props.originalState, s => s.optionId === optionId)
        }
        return value ? value.stringValue : ''
    }

    render() {
        const { data, answermap } = this.props
        const { rows } = this.state

        const tableStyle = {
            fontSize: '10px'
        }

        const questionComment = this.getCommentForQuestion(data.id)

        return (
            <div className="question-group type-numeric">
                <p style={{ fontSize: '15px', lineHeight: '1.3em' }}>
                    {replaceExpression(data.questionText, answermap)}
                </p>
                <div
                    style={{
                        fontSize: '11px',
                        fontStyle: 'italic',
                        lineHeight: '1.4em',
                    }}
                    dangerouslySetInnerHTML={{
                        __html: replaceExpression(data.explanation, answermap),
                    }}
                />
                <table style={tableStyle} width="100%">
                    <tbody>
                    <tr>
                        <td width="60%">&nbsp;</td>
                        <td width="20%">Ingevuld</td>
                        <td width="20%">Aangepast</td>
                    </tr>
                    {rows.map((row) => (
                        <tr key={row.row}>
                            {row.columns.map((option, i) => (
                                <TableColumn
                                    key={i + option.column}
                                    option={option}
                                    answermap={answermap}
                                    value={this.getValue(option.id)}
                                    originalValue={this.getOriginalValue(option.id)}
                                />
                            ))}
                        </tr>
                    ))}
                    </tbody>
                </table>
                {questionComment && (
                    <div
                        style={{
                            paddingTop: '5px',
                            fontSize: '15px',
                            fontStyle: 'italic',
                            marginBottom: '20px',
                        }}
                    >
                        <strong>Toelichting:</strong> {questionComment}
                    </div>
                )}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/PrintNumericQuestion.js